<template>
  <div class="wrap">
    <progress-circle
      class="score-progress"
      v-model="scorePercent"
      PERIMETER="1570"
      color="#FED838"
      layerColor="rgba(255,255,255,0.5)"
      :pathFn="pathFn"
      :speed="20"
    >
      <svg class="dash-image" viewBox="0 0 1636 1636">
        <template v-for="(item, index) in computedDotOptions">
          <text
            :key="'t' + index"
            :x="item.x - item.tx"
            :y="item.y - item.ty"
            font-size="55"
            :stroke="item.color"
            :fill="item.color"
            :opacity="item.rate * 100 <= scorePercent ? 1 : 0.3"
          >
            {{ item.text }}
          </text>
          <circle
            :key="'c' + index"
            r="10"
            :cx="item.x"
            :cy="item.y"
            :fill="item.color"
            :opacity="item.rate * 100 <= scorePercent ? 1 : 0.3"
          ></circle>
        </template>
      </svg>
    </progress-circle>
    <div class="score-count">
      <count-to
        ref="countTo"
        :startVal="0"
        :endVal="computedScore"
        :duration="1200"
        :autoplay="false"
      />
    </div>
    <div
      class="button-faq"
      @click="openFaq">{{$t('components_scoreexplain_dashboard_1479')}}<fps-icon type="arrow-right" />
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import progressCircle from '@/components/common/progress-bar/circle.vue'
import { parseNum } from '@/filters'

export default {
  components: {
    countTo,
    progressCircle,
  },
  data() {
    return {
      dotOptions: [
        { text: 0, rate: -0.01, color: '#979797', tx: 55, ty: 0 },
        { text: 400, rate: 0.25, color: '#979797', tx: 115, ty: 0 },
        { text: 800, rate: 0.5, color: '#979797', tx: 48, ty: 30 },
        // { text: 1000, rate: 0.625, color: '#979797', tx: -15, ty: 0 },
        { text: 1200, rate: 0.75, color: '#979797', tx: -15, ty: 0 },
        { text: '1600+', rate: 1.01, color: '#979797', tx: -15, ty: 0 }
      ],
      scorePercent: 0,
    }
  },
  props: {
    score: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    computedScore() {
      return +parseNum(this.score)
    },
    computedDotOptions() {
      return this.dotOptions.map(item => {
        let { x, y } = this.getCoord(item.rate);
        return { ...item, x, y };
      });
    }
  },
  methods: {
    // 触发动画
    animate() {
      this.$nextTick(() => {
        this.$refs.countTo.start()
        this.scorePercent = 0
        setTimeout(() => {
          this.scorePercent = ((this.computedScore / 1600) * 100) | 0
        }, 0)
      })
    },
    /**
     * @description: 自定义进程条,具体用法参见svg d属性
     * @param {type} clockwise 顺时针还是逆时针
     * @param {type} viewBoxSize 展示区尺寸
     * @return:
     */
    pathFn(clockwise, viewBoxSize) {
      const sweepFlag = clockwise ? 1 : 0;
      return `M ${viewBoxSize / 2} ${viewBoxSize / 2} m -500, 0 a 500, 500 0 1, ${sweepFlag} 1000, 0`;
    },
    /**
     * @description: 获取尺标位置
     */
    getCoord(rate) {
      let pi = Math.PI;
      let x = (818 - Math.cos(rate * pi) * 570) | 0;
      let y = (818 - Math.sin(rate * pi) * 570) | 0;
      return { x, y };
    },
    openFaq() {
      this.$util.openWindow('/player-score')
    },
  }
}
</script>

<style lang="scss" scoped>
  .wrap {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .score-progress {
    position: absolute;
    width: 200px;
    height: 100px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .dash-image {
      position: absolute;
      top: -50px;
      left: 50%;
      width: 300px;
      height: 300px;
      transform: translateX(-50%);
    }
  }
  .score-count {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 50%;
    width: 100%;
    margin-top: 10px;
    line-height: 1;
    color: #333;
    font-size: 36px;
    line-height: 36px;
    font-weight: 500;
    text-align: center;
  }
  .button-faq {
    @include flex;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 60px);
    width: 140px;
    height: 28px;
    font-size: 13px;
    color: #333;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
    cursor: pointer;
  }
</style>
